module.exports = __webpack_public_path__ + "img/mail_icon_unread.7516f90c.png";